<template lang="pug">
#app
  <router-view/>
  <FooterVue></FooterVue>
</template>

<script>
import FooterVue from './components/content_footer.vue'

export default {
  name: 'App',
  components: {
    FooterVue
  }
}
</script>

<style lang="scss">
@import 'assets/stylesheets/html5doctor';
@import 'assets/stylesheets/common';
@import url('https://fonts.googleapis.com/earlyaccess/notosansjp.css');

#app {
  font-family: 'Noto Sans JP', sans-serif;
}
.sans-serif {
  font-family: sans-serif;
}
</style>
